import React, { Component } from 'react';

/**
 * This is a static react port of the cdc template twitter logo svg
 */

export default class TwitterLogo extends Component {

    render() {
        return (
            <svg width="25" height="24" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M389.2 48H459.8L305.6 224.2L487 464H345L233.7 318.6L106.5 464H35.8L200.7 275.5L26.8 48H172.4L272.9 180.9L389.2 48ZM364.4 421.8H403.5L151.1 88H109.1L364.4 421.8Z" fill="white" />
            </svg>
        );
    }

}
